// @flow

import React from 'react';
import cx from 'classnames';
import '../styles/loader.scss';

type Props = {
  isFullScreen: boolean,
};

export default class Loader extends React.PureComponent<Props> {
  static defaultProps = {
    isFullScreen: false,
  };

  render() {
    return (
      <span className={cx('loader', { 'full-screen': this.props.isFullScreen })}>
        <svg className="circular">
          <circle
            className="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="3"
            strokeMiterlimit="10" />
        </svg>
      </span>
    );
  }
}
